export const CRM_CALLING = 'CRM_CALLING';
export const CRM_CANNED_SNIPPETS = 'CRM_CANNED_SNIPPETS';
export const CRM_COMPANY_RECORDS = 'CRM_COMPANY_RECORDS';
export const CRM_CONTACT_COMPANY_INSIGHTS = 'CRM_CONTACT_COMPANY_INSIGHTS';
export const CRM_CONTACT_ACTIVITY = 'CRM_CONTACT_ACTIVITY';
export const CRM_CONTACT_MANAGEMENT = 'CRM_CONTACT_MANAGEMENT';
export const CRM_CONVERSATIONAL_BOTS = 'CRM_CONVERSATIONAL_BOTS';
export const CRM_CONVERSATIONS_INBOX = 'CRM_CONVERSATIONS_INBOX';
export const CRM_DATA_SYNC = 'CRM_DATA_SYNC';
export const CRM_DEALS = 'CRM_DEALS';
export const CRM_DOCUMENTS = 'CRM_DOCUMENTS';
export const CRM_EMAIL_SCHEDULING = 'CRM_EMAIL_SCHEDULING';
export const CRM_EMAIL_TEMPLATES = 'CRM_EMAIL_TEMPLATES';
export const CRM_EMAIL_TRACKING_NOTIFICATIONS = 'CRM_EMAIL_TRACKING_NOTIFICATIONS';
export const CRM_FACEBOOK_INSTAGRAM_LEAD_ADS = 'CRM_FACEBOOK_INSTAGRAM_LEAD_ADS';
export const CRM_FORMS = 'CRM_FORMS';
export const CRM_GMAIL_OUTLOOK_INTEGRATION = 'CRM_GMAIL_OUTLOOK_INTEGRATION';
export const CRM_LINKEDIN_SYNC = 'CRM_LINKEDIN_SYNC';
export const CRM_LIVE_CHAT = 'CRM_LIVE_CHAT';
export const CRM_MEETINGS = 'CRM_MEETINGS';
export const CRM_PROSPECTS = 'CRM_PROSPECTS';
export const CRM_REPORTING_DASHBOARD = 'CRM_REPORTING_DASHBOARD';
export const CRM_TASKS = 'CRM_TASKS';
export const CRM_TEAM_EMAIL = 'CRM_TEAM_EMAIL';
export const CRM_TICKETING = 'CRM_TICKETING';
export const MARKETING_AB_TESTING = 'MARKETING_AB_TESTING';
export const MARKETING_AD_MANAGEMENT = 'MARKETING_AD_MANAGEMENT';
export const MARKETING_ATTRIBUTION_REPORTING = 'MARKETING_ATTRIBUTION_REPORTING';
export const MARKETING_BLOG_CONTENT_CREATION = 'MARKETING_BLOG_CONTENT_CREATION';
export const MARKETING_CTAS = 'MARKETING_CTAS';
export const MARKETING_CMS_MEMBERSHIP = 'MARKETING_CMS_MEMBERSHIP';
export const MARKETING_CONTACT_COMPANY_INSIGHTS = 'MARKETING_CONTACT_COMPANY_INSIGHTS';
export const MARKETING_CONTACT_ACTIVITY = 'MARKETING_CONTACT_ACTIVITY';
export const MARKETING_CONTACT_MANAGEMENT = 'MARKETING_CONTACT_MANAGEMENT';
export const MARKETING_CONTENT_PARTITIONING = 'MARKETING_CONTENT_PARTITIONING';
export const MARKETING_CONVERSATIONAL_BOTS = 'MARKETING_CONVERSATIONAL_BOTS';
export const MARKETING_CONVERSATIONS_INBOX = 'MARKETING_CONVERSATIONS_INBOX';
export const MARKETING_CUSTOM_EVENT_REPORTING = 'MARKETING_CUSTOM_EVENT_REPORTING';
export const MARKETING_CUSTOM_EVENT_TRIGGERS = 'MARKETING_CUSTOM_EVENT_TRIGGERS';
export const MARKETING_CUSTOM_REPORTING = 'MARKETING_CUSTOM_REPORTING';
export const MARKETING_EMAIL_MARKETING = 'MARKETING_EMAIL_MARKETING';
export const MARKETING_EMAIL_SEND_FREQUENCY_CAP = 'MARKETING_EMAIL_SEND_FREQUENCY_CAP';
export const MARKETING_FACEBOOK_MESSENGER_TOOLS = 'MARKETING_FACEBOOK_MESSENGER_TOOLS';
export const MARKETING_FORMS = 'MARKETING_FORMS';
export const MARKETING_GOAL_BASED_NURTURING = 'MARKETING_GOAL_BASED_NURTURING';
export const MARKETING_GOOGLE_SEARCH_CONSOLE_INTEGRATION = 'MARKETING_GOOGLE_SEARCH_CONSOLE_INTEGRATION';
export const MARKETING_HUBSPOT_BRANDING_REMOVED = 'MARKETING_HUBSPOT_BRANDING_REMOVED';
export const MARKETING_LANDING_PAGES = 'MARKETING_LANDING_PAGES';
export const MARKETING_LISTS = 'MARKETING_LISTS';
export const MARKETING_LIVE_CHAT = 'MARKETING_LIVE_CHAT';
export const MARKETING_MARKETING_AUTOMATION = 'MARKETING_MARKETING_AUTOMATION';
export const MARKETING_MOBILE_OPTIMIZATION = 'MARKETING_MOBILE_OPTIMIZATION';
export const MARKETING_PHONE_SUPPORT = 'MARKETING_PHONE_SUPPORT';
export const MARKETING_POPUP_FORMS = 'MARKETING_POPUP_FORMS';
export const MARKETING_PREDICTIVE_LEAD_SCORING = 'MARKETING_PREDICTIVE_LEAD_SCORING';
export const MARKETING_REPORTING_DASHBOARDS = 'MARKETING_REPORTING_DASHBOARDS';
export const MARKETING_SALESFORCE_INTEGRATION = 'MARKETING_SALESFORCE_INTEGRATION';
export const MARKETING_SEO_CONTENT_STRATEGY = 'MARKETING_SEO_CONTENT_STRATEGY';
export const MARKETING_SSO = 'MARKETING_SSO';
export const MARKETING_SMART_CONTENT = 'MARKETING_SMART_CONTENT';
export const MARKETING_SOCIAL = 'MARKETING_SOCIAL';
export const MARKETING_SSL = 'MARKETING_SSL';
export const MARKETING_SUBDOMAIN_AVAILABILITY = 'MARKETING_SUBDOMAIN_AVAILABILITY';
export const MARKETING_TEAM_EMAIL = 'MARKETING_TEAM_EMAIL';
export const MARKETING_TEAMS = 'MARKETING_TEAMS';
export const MARKETING_VIDEO = 'MARKETING_VIDEO';
export const MARKETING_YOUTUBE_INTEGRATION = 'MARKETING_YOUTUBE_INTEGRATION';
export const SALES_1_1_VIDEO_CREATION = 'SALES_1_1_VIDEO_CREATION';
export const SALES_CALCULATED_PROPERTIES = 'SALES_CALCULATED_PROPERTIES';
export const SALES_CALL_TRANSCRIPTION_REPORTING = 'SALES_CALL_TRANSCRIPTION_REPORTING';
export const SALES_CALLING = 'SALES_CALLING';
export const SALES_CANNED_SNIPPETS = 'SALES_CANNED_SNIPPETS';
export const SALES_COMPANY_RECORDS = 'SALES_COMPANY_RECORDS';
export const SALES_CONTACT_COMPANY_INSIGHTS = 'SALES_CONTACT_COMPANY_INSIGHTS';
export const SALES_CONTACT_MANAGEMENT = 'SALES_CONTACT_MANAGEMENT';
export const SALES_CONVERSATION_ROUTING = 'SALES_CONVERSATION_ROUTING';
export const SALES_CONVERSATIONAL_BOTS = 'SALES_CONVERSATIONAL_BOTS';
export const SALES_CONVERSATIONS_INBOX = 'SALES_CONVERSATIONS_INBOX';
export const SALES_CUSTOM_REPORTING = 'SALES_CUSTOM_REPORTING';
export const SALES_DEALS = 'SALES_DEALS';
export const SALES_DOCUMENTS = 'SALES_DOCUMENTS';
export const SALES_EMAIL_SCHEDULING = 'SALES_EMAIL_SCHEDULING';
export const SALES_EMAIL_SEQUENCES = 'SALES_EMAIL_SEQUENCES';
export const SALES_EMAIL_TEMPLATES = 'SALES_EMAIL_TEMPLATES';
export const SALES_EMAIL_TRACKING_NOTIFICATIONS = 'SALES_EMAIL_TRACKING_NOTIFICATIONS';
export const SALES_ESIGNATURE = 'SALES_ESIGNATURE';
export const SALES_GMAIL_AND_OUTLOOK_INTEGRATION = 'SALES_GMAIL_AND_OUTLOOK_INTEGRATION';
export const SALES_GOALS = 'SALES_GOALS';
export const SALES_HUBSPOT_BRANDING_REMOVED = 'SALES_HUBSPOT_BRANDING_REMOVED';
export const SALES_LIVE_CHAT = 'SALES_LIVE_CHAT';
export const SALES_MEETING_SCHEDULING = 'SALES_MEETING_SCHEDULING';
export const SALES_MULTIPLE_CURRENCIES = 'SALES_MULTIPLE_CURRENCIES';
export const SALES_MULTIPLE_DEAL_PIPELINES = 'SALES_MULTIPLE_DEAL_PIPELINES';
export const SALES_PHONE_SUPPORT = 'SALES_PHONE_SUPPORT';
export const SALES_PLAYBOOKS = 'SALES_PLAYBOOKS';
export const SALES_PREDICTIVE_LEAD_SCORING = 'SALES_PREDICTIVE_LEAD_SCORING';
export const SALES_PRODUCTS = 'SALES_PRODUCTS';
export const SALES_PROSPECTS = 'SALES_PROSPECTS';
export const SALES_QUOTE_APPROVALS = 'SALES_QUOTE_APPROVALS';
export const SALES_QUOTES = 'SALES_QUOTES';
export const SALES_RECURRING_REVENUE_TRACKING = 'SALES_RECURRING_REVENUE_TRACKING';
export const SALES_REPORTING_DASHBOARDS = 'SALES_REPORTING_DASHBOARDS';
export const SALES_REQUIRED_FIELDS = 'SALES_REQUIRED_FIELDS';
export const SALES_SALES_AUTOMATION = 'SALES_SALES_AUTOMATION';
export const SALES_SALESFORCE_INTEGRATION = 'SALES_SALESFORCE_INTEGRATION';
export const SALES_SINGLE_SIGN_ON = 'SALES_SINGLE_SIGN_ON';
export const SALES_SMART_NOTIFICATIONS = 'SALES_SMART_NOTIFICATIONS';
export const SALES_SMART_SEND_TIMES = 'SALES_SMART_SEND_TIMES';
export const SALES_TASKS = 'SALES_TASKS';
export const SALES_TEAM_EMAIL = 'SALES_TEAM_EMAIL';
export const SALES_TEAMS = 'SALES_TEAMS';
export const SERVICE_1_1_VIDEO_CREATION_HOSTING = 'SERVICE_1_1_VIDEO_CREATION_HOSTING';
export const SERVICE_CALCULATED_PROPERTIES = 'SERVICE_CALCULATED_PROPERTIES';
export const SERVICE_CALLING = 'SERVICE_CALLING';
export const SERVICE_CANNED_SNIPPETS = 'SERVICE_CANNED_SNIPPETS';
export const SERVICE_CONVERSATION_ROUTING = 'SERVICE_CONVERSATION_ROUTING';
export const SERVICE_CONVERSATIONAL_BOTS = 'SERVICE_CONVERSATIONAL_BOTS';
export const SERVICE_CONVERSATIONS_INBOX = 'SERVICE_CONVERSATIONS_INBOX';
export const SERVICE_CUSTOM_REPORTING = 'SERVICE_CUSTOM_REPORTING';
export const SERVICE_CUSTOM_SUPPORT_FORM_FIELDS = 'SERVICE_CUSTOM_SUPPORT_FORM_FIELDS';
export const SERVICE_CUSTOMER_FEEDBACK = 'SERVICE_CUSTOMER_FEEDBACK';
export const SERVICE_CUSTOMER_SERVICE_AUTOMATION = 'SERVICE_CUSTOMER_SERVICE_AUTOMATION';
export const SERVICE_EMAIL_CHAT_TO_TICKET = 'SERVICE_EMAIL_CHAT_TO_TICKET';
export const SERVICE_EMAIL_SEQUENCES = 'SERVICE_EMAIL_SEQUENCES';
export const SERVICE_EMAIL_TEMPLATES = 'SERVICE_EMAIL_TEMPLATES';
export const SERVICE_GOALS = 'SERVICE_GOALS';
export const SERVICE_HUBSPOT_BRANDING_REMOVED = 'SERVICE_HUBSPOT_BRANDING_REMOVED';
export const SERVICE_KNOWLEDGE_BASE = 'SERVICE_KNOWLEDGE_BASE';
export const SERVICE_LIVE_CHAT = 'SERVICE_LIVE_CHAT';
export const SERVICE_MEETING_SCHEDULING = 'SERVICE_MEETING_SCHEDULING';
export const SERVICE_MULTIPLE_CURRENCIES = 'SERVICE_MULTIPLE_CURRENCIES';
export const SERVICE_MULTIPLE_TICKET_PIPELINES = 'SERVICE_MULTIPLE_TICKET_PIPELINES';
export const SERVICE_PHONE_SUPPORT = 'SERVICE_PHONE_SUPPORT';
export const SERVICE_PLAYBOOKS = 'SERVICE_PLAYBOOKS';
export const SERVICE_REPORTING_DASHBOARDS = 'SERVICE_REPORTING_DASHBOARDS';
export const SERVICE_SALESFORCE_INTEGRATION = 'SERVICE_SALESFORCE_INTEGRATION';
export const SERVICE_SINGLE_SIGN_ON = 'SERVICE_SINGLE_SIGN_ON';
export const SERVICE_TEAM_EMAIL = 'SERVICE_TEAM_EMAIL';
export const SERVICE_TEAMS = 'SERVICE_TEAMS';
export const SERVICE_TICKETING = 'SERVICE_TICKETING';
export const CMS_AB_TESTING = 'CMS_AB_TESTING';
export const CMS_ACTIVITY_LOGGING = 'CMS_ACTIVITY_LOGGING';
export const CMS_ADAPTIVE_TESTING = 'CMS_ADAPTIVE_TESTING';
export const CMS_AMP_SUPPORT_FOR_BLOGS = 'CMS_AMP_SUPPORT_FOR_BLOGS';
export const CMS_BLOG = 'CMS_BLOG';
export const CMS_BLOG_IMPORT = 'CMS_BLOG_IMPORT';
export const CMS_CALCULATED_PROPERTIES = 'CMS_CALCULATED_PROPERTIES';
export const CMS_CALLS_TO_ACTION = 'CMS_CALLS_TO_ACTION';
export const CMS_CODE_ALERTS = 'CMS_CODE_ALERTS';
export const CMS_CONTACT_ATTRIBUTION_REPORT_BUILDER = 'CMS_CONTACT_ATTRIBUTION_REPORT_BUILDER';
export const CMS_CONTENT_ANALYTICS_VIEWS = 'CMS_CONTENT_ANALYTICS_VIEWS';
export const CMS_CONTENT_DELIVERY_NETWORK = 'CMS_CONTENT_DELIVERY_NETWORK';
export const CMS_CONTENT_STAGING = 'CMS_CONTENT_STAGING';
export const CMS_CONVERSATIONAL_BOTS = 'CMS_CONVERSATIONAL_BOTS';
export const CMS_CONVERSATIONS_INBOX = 'CMS_CONVERSATIONS_INBOX';
export const CMS_CUSTOM_CDN_CONFIGURATION = 'CMS_CUSTOM_CDN_CONFIGURATION';
export const CMS_CUSTOM_DOMAINS = 'CMS_CUSTOM_DOMAINS';
export const CMS_CUSTOM_REPORTING = 'CMS_CUSTOM_REPORTING';
export const CMS_DESIGN_MANAGER = 'CMS_DESIGN_MANAGER';
export const CMS_DRAG_AND_DROP_EDITOR = 'CMS_DRAG_AND_DROP_EDITOR';
export const CMS_DYNAMIC_CONTENT_WITH_HUBDB = 'CMS_DYNAMIC_CONTENT_WITH_HUBDB';
export const CMS_EMAIL_MARKETING = 'CMS_EMAIL_MARKETING';
export const CMS_FORMS = 'CMS_FORMS';
export const CMS_LANDING_PAGES = 'CMS_LANDING_PAGES';
export const CMS_LIST_SEGMENTATION = 'CMS_LIST_SEGMENTATION';
export const CMS_LIVE_CHAT = 'CMS_LIVE_CHAT';
export const CMS_LOCAL_WEBSITE_DEVELOPMENT = 'CMS_LOCAL_WEBSITE_DEVELOPMENT';
export const CMS_MEMBERSHIPS = 'CMS_MEMBERSHIPS';
export const CMS_MOBILE_OPTIMIZATION = 'CMS_MOBILE_OPTIMIZATION';
export const CMS_MULTIPLE_CURRENCIES = 'CMS_MULTIPLE_CURRENCIES';
export const CMS_MULTI_LANGUAGE_CONTENT_CREATION_AND_TESTING = 'CMS_MULTI_LANGUAGE_CONTENT_CREATION_AND_TESTING';
export const CMS_PASSWORD_PROTECTED_PAGES = 'CMS_PASSWORD_PROTECTED_PAGES';
export const CMS_RECORD_CUSTOMIZATION = 'CMS_RECORD_CUSTOMIZATION';
export const CMS_REPORTING_DASHBOARD = 'CMS_REPORTING_DASHBOARD';
export const CMS_REVERSE_PROXY_SUPPORT = 'CMS_REVERSE_PROXY_SUPPORT';
export const CMS_SEO_CONTENT_STRATEGY = 'CMS_SEO_CONTENT_STRATEGY';
export const CMS_SERVERLESS_FUNCTIONS = 'CMS_SERVERLESS_FUNCTIONS';
export const CMS_SINGLE_SIGN_ON = 'CMS_SINGLE_SIGN_ON';
export const CMS_SITE_EXPORT = 'CMS_SITE_EXPORT';
export const CMS_SITE_PERFORMANCE_MONITORING = 'CMS_SITE_PERFORMANCE_MONITORING';
export const CMS_SMART_CONTENT_REPORTING = 'CMS_SMART_CONTENT_REPORTING';
export const CMS_STANDARD_CONTACT_SCORING = 'CMS_STANDARD_CONTACT_SCORING';
export const CMS_STANDARD_SSL_CERTIFICATE = 'CMS_STANDARD_SSL_CERTIFICATE';
export const CMS_SUBDOMAIN_AND_COUNTRY_CODE_TLD_AVAILABILITY = 'CMS_SUBDOMAIN_AND_COUNTRY_CODE_TLD_AVAILABILITY';
export const CMS_TWO_BRAND_DOMAINS = 'CMS_TWO_BRAND_DOMAINS';
export const CMS_URL_MAPPINGS = 'CMS_URL_MAPPINGS';
export const CMS_VIDEO_HOSTING_MANAGEMENT = 'CMS_VIDEO_HOSTING_MANAGEMENT';
export const CMS_WEBSITE_PAGES = 'CMS_WEBSITE_PAGES';
export const CMS_WEBSITE_THEMES = 'CMS_WEBSITE_THEMES';
export const CMS_WEBSITE_TRAFFIC_ANALYTICS = 'CMS_WEBSITE_TRAFFIC_ANALYTICS';
export const OPS_HUB_CUSTOM_FIELD_MAPPINGS = 'OPS_HUB_CUSTOM_FIELD_MAPPINGS';